import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { type components } from 'src/api/playerPayback/api'
import { useCurrentStateStore } from 'stores/useCurrentStateStore'

export const useGetOrganizationById = ({
  organizationId,
}: {
  organizationId: number
  enabled?: boolean
}): UseQueryResult<components['schemas']['FullOrganizationDTO']> => {
  const get = useTypedApiClient({
    path: '/admin/organizations/{id}',
    method: 'get',
  })
  const { currentStateId } = useCurrentStateStore()

  return useQuery({
    queryKey: ['/admin/organizations', organizationId],
    queryFn: async () => {
      const { data } = await get(
        {
          id: organizationId,
        },
        currentStateId
          ? { headers: { 'Current-State-Id': currentStateId.toString() } }
          : undefined
      )
      return data
    },
  })
}
